import processosRoutes from './processos/rotas.js';

const allRules = processosRoutes.flatMap((r) => r.meta?.rules ?? []);

const routes = {
    path: 'consultas',
    name: 'Consultas',
    component: () => import('./Consultas.vue'),
    children: [...processosRoutes],
    meta: {
        rules: [...new Set(allRules)],
    },
};

export default routes;
